import React from "react";

const StyledH3Heading = ({ children, font }) => {
  return (
    <h3 className={`text-h3 font-star-jedi lowercase leading-[130%] ${font}`}>
      {children}
    </h3>
  );
};

export default StyledH3Heading;
